import { WorkflowArea } from '../../../../aumico-lib-cpmm-fe/src/lib/enums/workflow-area.enum';
import { IssueDetailDto } from './issue-detail.dto.interface';

export interface WorkflowDataDto {
    area: WorkflowArea;
    summary: string;
    totalIssueCount: number;
    completedIssueCount: number;
    issuesDetails: IssueDetailDto[];
}
